<template>
  <div class="clear">
    <h2>{{ experience.job }}</h2>
    <small>
      <a
        v-if="experience.link"
        :href="experience.link"
        class="btn btn-link"
        target="_blank"
        >{{ experience.company }}</a
      >
      <span v-else>{{ experience.company }}</span>
      | {{ experience.date }}</small
    >
    <p v-if="toggleText">
      {{ experience.desc[0] + "..." }}
    </p>
    <p
      v-else
      v-for="(paragraph, index) in experience.desc"
      :key="index"
      :data-index="index"
    >
      {{ paragraph }}
    </p>
    <ReadMoreButton
      v-if="experience.desc[0]"
      :toggleText="toggleText"
      @readMore="handleButton($event)"
    />
  </div>
</template>

<script>
import { ref } from "vue";
import { ReadMoreButton } from "../../components";
export default {
  props: {
    experience: Object,
  },
  components: { ReadMoreButton },
  setup() {
    const toggleText = ref(true);
    const handleButton = (val) => (toggleText.value = val);
    return {
      toggleText,
      handleButton,
    };
  },
};
</script>

<style scoped>
#resume .btn-link {
  color: var(--primary);
}
</style>
